import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        },
        {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页'
          }
        },
        {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/product/Software'], resolve),
          meta: {
            title: '产品中心'
          },
        },
        {
          path: '/software/big',
          name: 'softwaree',
          component: resolve => require(['@/view/product/Software_bigData'], resolve),
          meta: {
            title: '产品中心'
          },
        },
        {
          path: '/Ares',
          name: 'Ares',
          component: resolve => require(['@/view/product/Product-Ares'], resolve),
          meta: {
            title: '产品中心 | Ares 3.0'
          },
        },
        {
          path: '/Poseidon',
          name: 'Poseidon',
          component: resolve => require(['@/view/product/Product-Poseidon'], resolve),
          meta: {
            title: '产品中心 | Poseidon'
          },
        },
        {
          path: '/Aphrodite',
          name: 'Aphrodite',
          component: resolve => require(['@/view/product/Product-Aphrodite'], resolve),
          meta: {
            title: '产品中心 | Aphrodite'
          },
        },
        {
          path: '/Hermes',
          name: 'Hermes',
          component: resolve => require(['@/view/product/Product-Hermes'], resolve),
          meta: {
            title: '产品中心 | Hermes'
          },
        },
        {
          path: '/Blackhead',
          name: 'Blackhead',
          component: resolve => require(['@/view/product/Product-Blackhead'], resolve),
          meta: {
            title: '产品中心 | Blackhead USB'
          },
        },
        {
          path: '/Rotate',
          name: 'Rotate',
          component: resolve => require(['@/view/product/Product-Rotate'], resolve),
          meta: {
            title: '产品中心 | Rotate USB'
          },
        },
        {
          path: '/ShuiXing',
          name: 'Rotate',
          component: resolve => require(['@/view/product/Product-Shuixing'], resolve),
          meta: {
            title: '产品中心 | 水星'
          },
        },
        {
          path: '/core',
          name: 'core',
          component: resolve => require(['@/view/core'], resolve),
          meta: {
            title: '我们的工厂'
          },
        },
        {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '关于我们'
          },
        },
        {
          path: '/ContactUs',
          name: 'ContactUs',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          },
        },
        {
          path: '/JobChance',
          name: 'JobChance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '意向单'
          },
        },
      ]
    }
  ],
  scrollBehavior() {
    return {x: 0, y: 0};
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js